<script lang="ts">
	import { ProgressRadial } from '@skeletonlabs/skeleton';
	import { onMount } from 'svelte';
	import { blur } from 'svelte/transition';

	export let loading = false,
		text: string | undefined = undefined,
		variant: 'save' | 'submit' | 'archive' | 'delete' = 'submit',
		formAction: string | undefined = undefined,
		disabled: boolean = false;

	let btn: HTMLButtonElement,
		variantStyle = {
			btn: 'variant-ghost-primary',
			meter: 'stroke-primary-500',
			track: 'stroke-primary-500/30'
		};

	// Define the variant styles and text
	if (variant === 'save') {
		!text && (text = 'Guardar');
		variantStyle = {
			btn: 'variant-ghost-success',
			meter: 'stroke-success-500',
			track: 'stroke-success-500/30'
		};
	}
	if (variant === 'archive') {
		!text && (text = 'Archivar');
		variantStyle = {
			btn: 'variant-ghost-error',
			meter: 'stroke-error-500',
			track: 'stroke-error-500/30'
		};
	}
	if (variant === 'delete') {
		!text && (text = 'Eliminar');
		variantStyle = {
			btn: 'variant-ghost-error',
			meter: 'stroke-error-500',
			track: 'stroke-error-500/30'
		};
	}
	!text && (text = 'Enviar');

	onMount(() => {
		if (formAction) {
			btn.formAction = formAction;
		}
	});
</script>

<button
	bind:this={btn}
	{disabled}
	class="btn relative xsm:self-end {variantStyle.btn} {$$props.class} {loading && 'cursor-wait'}"
>
	<span class:opacity-0={loading}>{text}</span>
	{#if loading}
		<span transition:blur|local class="!absolute">
			<ProgressRadial class="w-5" stroke={250} meter={variantStyle.meter} track={variantStyle.track} />
		</span>
	{/if}
</button>
